<template>
  <Box>
    <div class="box-values">
      <Values :data="total" />

      <v-spacer />

      <div>
        <CarCategory
          v-if="featuredCategoryVisible"
          :data="rideCategoryGroup.mostUsed"
          tooltip
        />

        <CategoriesAction
          :isClosed="categoriesVisible"
          :percentage="rideCategoryGroup.lessUsedSum"
          @toggleVisibility="toggleVisibility"
        />
      </div>
    </div>

    <Categories
      v-show="categoriesVisible"
      :categories="rideCategoryOrdened"
    />
  </Box>
</template>

<script>
import Values from './Values'
import CarCategory from 'components/CarCategory'
import CategoriesAction from './CategoriesAction'
import Categories from './Categories'

export default {
  name: 'ValuesBox',
  props: {
    total: {
      type: Object
    },
    categoriesVisible: {
      type: Boolean,
      default: false
    },
    featuredCategoryVisible: {
      type: Boolean,
      default: true
    },
    rideCategoryGroup: {
      type: Object
    },
    rideCategoryOrdened: {
      type: Array
    }
  },
  components: {
    Values,
    CarCategory,
    CategoriesAction,
    Categories
  },
  methods: {
    toggleVisibility () {
      this.$emit('toggleVisibility')
    }
  }
}
</script>

<style lang="scss" scoped>
.box-values {
  align-items: stretch;
  flex-direction: column;
  display: flex;

  @media (min-width: 650px) {
    align-items: center;
    flex-direction: row;
  }

  @media (min-width: 1140px) and (max-width: 1350px) {
    align-items: stretch;
    flex-direction: column;
  }

  .values {
    margin-bottom: 8px;

    @media (min-width: 650px) {
      align-items: center;
      flex-direction: row;
      margin-bottom: 0;
    }

    @media (min-width: 1140px) and (max-width: 1350px) {
      margin-bottom: 8px;
    }
  }
}
</style>
